// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "facial-academy-d0335.firebaseapp.com",
  "projectId": "facial-academy-d0335",
  "storageBucket": "facial-academy-d0335.appspot.com",
  "messagingSenderId": "75492478646",
  "appId": "1:75492478646:web:82856e6ceef77a695ae017",
  "measurementId": "G-DC37SZXPCL",
  "apiKey": "AIzaSyC4_MRDhU7DiT3FF1U_Tw3CPhvaQFvI5Mg"
};
